// Format currency IDR
export const formatCurrency = (amount) => {
  if (amount == null) return 'Rp 0';
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

// Format number
export const formatNumber = (num, decimals = 0) => {
  if (num == null) return '0';
  return new Intl.NumberFormat('id-ID', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(num);
};

// Format date
export const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString('id-ID', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
};

// Format date short
export const formatDateShort = (dateStr) => {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString('id-ID', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

// Format datetime
export const formatDateTime = (dateStr) => {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleString('id-ID', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

// Status tone mapping. The web app maps these to CSS badge classes
// to native colors. Keeping the mapping here means both stay in sync.
export const statusTone = (status) => {
  const map = {
    // General
    active: 'success', inactive: 'danger', draft: 'gray',
    pending: 'warning', approved: 'success', completed: 'success',
    cancelled: 'danger',
    // PO
    pending_approval: 'warning', sent: 'info', partial: 'warning',
    received: 'success',
    // Invoice
    unpaid: 'danger', paid: 'success', overdue: 'danger',
    // Stock
    in: 'success', out: 'danger', adjustment: 'info',
    transfer_in: 'info', transfer_out: 'warning',
    // Sales payment
    credit: 'warning',
  };
  return map[status] || 'gray';
};

// Web-only alias: CSS class name for a status tone.
export const statusBadgeClass = (status) => `badge-${statusTone(status)}`;

// Status labels
export const statusLabel = (status) => {
  const map = {
    active: 'Aktif', inactive: 'Nonaktif', draft: 'Draf',
    pending: 'Menunggu', approved: 'Disetujui', completed: 'Selesai',
    cancelled: 'Dibatalkan', pending_approval: 'Menunggu Persetujuan',
    sent: 'Dikirim', partial: 'Sebagian', received: 'Diterima',
    unpaid: 'Belum Dibayar', paid: 'Lunas', overdue: 'Jatuh Tempo',
    in: 'Masuk', out: 'Keluar', adjustment: 'Penyesuaian',
    transfer_in: 'Transfer Masuk', transfer_out: 'Transfer Keluar',
  };
  return map[status] || status;
};

// Truncate text
export const truncate = (str, length = 50) => {
  if (!str) return '';
  if (str.length <= length) return str;
  return str.substring(0, length) + '...';
};

// Debounce
export const debounce = (fn, delay = 300) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
};
